export const formatDateShort = (dateInput: string | Date): string => {
    const date = new Date(dateInput);
    if (Number.isNaN(date.getTime())) return "-";

    return date.toLocaleDateString("en-US", {
        month: "short",
        day: "2-digit",
        year: "numeric",
    });
};
